import { useEffect, useRef, useState } from "react";

export function ExpandInput({
  open,
  children,
}: {
  open: boolean;
  children: React.ReactNode;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (ref.current) setHeight(ref.current.scrollHeight);
  }, []);

  return (
    <div
      style={{
        maxHeight: open ? height : 0,
        opacity: open ? 1 : 0,
        marginTop: open ? 8 : 0,
        overflow: "hidden",
        transition:
          "max-height 0.32s cubic-bezier(0.4,0,0.2,1), opacity 0.22s ease, margin-top 0.28s ease",
      }}
    >
      <div ref={ref}>{children}</div>
    </div>
  );
}
